import { AiLogsTab } from '@/types/ai-logs';

export const AI_LOGS_ANALYTICS = 'AI_LOGS_ANALYTICS';

export const getAiLogsAnalyticsKey = (tab: AiLogsTab) => `${AI_LOGS_ANALYTICS}_${tab}`;
